/**
 * @function uniteMissionsDates
 * @description Flattens each mission's `{ date: cloudPercentage }` dictionary into a single list
 * of date entries. `mission.dates[date]` comes from Earth Engine's `CLOUDY_PIXEL_PERCENTAGE`/
 * `CLOUD_COVER` metadata (0-100), divided by 100 here so `content` lands on the same 0-1 fraction
 * scale as `CloudSelector`'s cloud-coverage threshold.
 * @param {Array<{name: string, shortname: string, dates: Object<string, number>}>} missions
 * **Called by:
 * @see {aggregateMissionsDates}
 * @see {PeriodImageChooser}
 * @memberof module:Shared
 * @returns {Array<{name: string, shortname: string, date: string, content: number}>}
 */
export const uniteMissionsDates = (missions) => {
  const union = [];

  missions.forEach((mission) => {
    Object.keys(mission.dates).forEach((date) => {
      union.push({
        name: mission.name,
        shortname: mission.shortname,
        date: date,
        content: mission.dates[date] / 100,
      });
    });
  });

  return union;
};

export const sortMissionsDates = (dates) => {
  return dates.sort((a, b) => new Date(a.date) - new Date(b.date));
};

export const aggregateMissionsDates = (missions) => {
  return sortMissionsDates(uniteMissionsDates(missions));
};
